import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import 'reflect-metadata';
import { PreviousRouteService } from './shared/previous-route.service';
import { AnalyticsService } from './shared/analytics.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'human-studio-next';

  private ngUnsubscribe = new Subject();

  constructor(
    previousRouteService: PreviousRouteService,
    private analyticsService: AnalyticsService,
    private router: Router
  ) {
    previousRouteService.loadRouting();
    analyticsService.init(environment.googleAnalyticsId);
  }

  ngOnInit() {
    // begin tracking
    this.initPageAnalytics();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initPageAnalytics() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        this.analyticsService.logPageView(url);
      });
  }
}
